import React from 'react'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'
import { isSuperUser } from 'utils/Auth'
import { debounce, flowRight } from 'lodash'

import Item from './Item'
import Styles from './index.scss'

import ModalConfirm from '../ModalConfirmation'
import ModalMerge from '../ModalMergeData'
import ModalAlert from '../ModalAlert'
import NameSort from './NameSort'
import QuantitySort from './QuantitySort'

const renderDeleteMessage = () => (
  <div>
    <span className={Styles['content-text']}>Confirm delete ? </span>
    <span className={Styles['content-text']}>Once confirmed you can't undo</span>
  </div>
)

const renderAddToPlatformMessage = () => (
  <div>
    <span className={Styles['content-text']}>Confirm add to platform ? </span>
    <span className={Styles['content-text']}>Once confirmed you can't undo</span>
  </div>
)

const renderMergeMessage = (currentSelectedData, inputName, typeMerge, existingDataSelected) => (
  <div>
    <span className={Styles['content-text']}>Confirm Merge ? </span>
    <span className={Styles['content-text']}>
      {`Are you sure you want to merge all ${currentSelectedData.length} into "${typeMerge === 'newData' ? inputName : existingDataSelected}"`}
    </span>
  </div>
)

const actionsConfirmation = (props) => {
  if (props.action === 'addToPlatform') {
    return props.addToPlatform
  } else if (props.action === 'delete') {
    return props.deleteData
  }
  return props.dataTypeActive === 'liveData' ? props.mergeDataLive : props.mergeData
}

const isDataSelected = (allSelectedData, currentData) => {
  const searchedData = allSelectedData.find(data => currentData.id === data.id)
  if (searchedData) {
    return true
  }
  return false
}

const TagUserSubmission = props => (
  <div className="row">
    <div className="col-md-12">
      <div className="portlet light portlet-fit">
        <div className="portlet-title">
          <div className="caption">
            <span className="caption-subject sbold uppercase">USER SUBMISSION</span>
          </div>
          <div className="actions">
            <input
              className={Styles.searchBar}
              placeholder="Search..."
              type="text"
              onChange={flowRight(debounce(props.onSearchFilter, 300), e => e.persist() || e)}
            />
            <button
              className={Styles.btnAction}
              onClick={props.clearSelection}
            >
              {`Clear Selected (${props.dataUserSubmissionSelected.length})`}
            </button>
            <button
              className={`${Styles.btnAction} ${props.dataUserSubmissionSelected.length === 0 ? Styles.btnDisabled : ''}`}
              onClick={props.setIsModalMergeOpen(true)}
              disabled={props.dataUserSubmissionSelected.length === 0}
            >
              Merge
            </button>
          </div>
        </div>
        <div className="portlet-body">
          <div className="table-scrollable table-scrollable-borderless">
            <table className="table table-hover table-light">
              <thead>
                <tr className="uppercase">
                  <th className={Styles['th-number']}> # </th>
                  <th />
                  <th>
                    <NameSort
                      userSubmissionFilter={props.userSubmissionFilter}
                      sortUserSubmissionData={props.sortUserSubmissionData}
                    />
                  </th>
                  <th>
                    <QuantitySort
                      userSubmissionFilter={props.userSubmissionFilter}
                      sortUserSubmissionData={props.sortUserSubmissionData}
                    />
                  </th>
                  {isSuperUser(props.user) &&
                    <th className={`table-actions ${Styles['th-actions']}`}> Actions </th>
                  }
                </tr>
              </thead>
              <tbody>
                {props.dataList.rows.map((tag, index) => (
                  <Item
                    key={tag.id}
                    tag={tag}
                    no={(index + 1) + ((props.dataList.currentPage - 1) * props.dataList.qs.limit)}
                    onActionsClick={props.openModal}
                    onAddToPlatform={props.openModalForAddToPlatform}
                    user={props.user}
                    onClickCheckBox={props.onClickCheckBox(tag)}
                    isDataSelected={isDataSelected(props.dataUserSubmissionSelected, tag)}
                  />
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="portlet-footer">
          {props.dataList.totalPages > 1 && (
            <ReactPaginate
              previousLabel={'<'}
              nextLabel={'>'}
              breakLabel={<a href="">...</a>}
              breakClassName={'break-me'}
              pageCount={props.dataList.totalPages}
              marginPagesDisplayed={3}
              pageRangeDisplayed={2}
              onPageChange={props.handlePageChange}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
              forcePage={props.dataList.currentPage - 1}
            />
          )}
        </div>
      </div>
    </div>
    <ModalMerge
      isOpen={props.isModalMergeOpen}
      selectedData={props.dataUserSubmissionSelected}
      onClose={props.setIsModalMergeOpen(false)}
      removeSelectedData={props.removeSelectedData}
      inputMergeName={props.inputMergeName}
      setInputMergeName={props.setInputMergeName}
      setOpenModalMerge={props.setOpenModalMerge}
      setTypeMerge={props.setTypeMerge}
      typeMerge={props.typeMerge}
      dataSelection={props.dataSelection}
      setExistingDataSelected={props.setExistingDataSelected}
      existingDataSelected={props.existingDataSelected}
      searchDataToMerge={props.searchDataToMerge}
      dataTypeActive={props.dataTypeActive}
      dataLiveSelected={props.dataLiveSelected}
    />
    <ModalConfirm
      onCloseModal={props.openModal}
      isModalOpen={props.isModalUserSubmissionOpen}
      onClickConfirm={actionsConfirmation(props)}
    >
      <div>
        {props.action === 'addToPlatform' && renderAddToPlatformMessage()}
        {props.action === 'delete' && renderDeleteMessage()}
        {props.action === 'merge' &&
          renderMergeMessage(
            props.dataUserSubmissionSelected.length > 0 ?
              props.dataUserSubmissionSelected : props.dataLiveSelected,
            props.inputMergeName,
            props.typeMerge,
            props.existingDataSelected)
        }
      </div>
    </ModalConfirm>
    <ModalAlert
      isOpen={props.isDialogAlertOpen}
      onClose={props.setIsDialogAlertOpen(false)}
      title={'Alert'}
      message={props.dialogAlertMessage}
    />
  </div>
)

TagUserSubmission.defaultProps = {
  onSearchFilter: () => { },
  onClickCheckBox: () => { },
  dataUserSubmissionSelected: [],
  clearSelection: () => { },
  isModalMergeOpen: false,
  setIsModalMergeOpen: () => { },
  removeSelectedData: () => { },
  setInputMergeName: () => { },
  setOpenModalMerge: () => { },
  mergeData: () => { },
  setTypeMerge: () => { },
  typeMerge: '',
  setExistingDataSelected: () => { },
  existingDataSelected: '',
  searchDataToMerge: () => { },
  setIsDialogAlertOpen: () => { },
  isDialogAlertOpen: false,
  dialogAlertMessage: '',
  dataLiveSelected: [],
  mergeDataLive: () => { },
}

TagUserSubmission.propTypes = {
  dataList: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.object),
    totalPages: PropTypes.number,
    currentPage: PropTypes.number.isRequired,
  }).isRequired,
  handlePageChange: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  isModalUserSubmissionOpen: PropTypes.bool.isRequired,
  action: PropTypes.string.isRequired,
  user: PropTypes.shape({}).isRequired,
  onSearchFilter: PropTypes.func,
  dataUserSubmissionSelected: PropTypes.arrayOf(PropTypes.object),
  clearSelection: PropTypes.func,
  isModalMergeOpen: PropTypes.bool,
  setIsModalMergeOpen: PropTypes.func,
  removeSelectedData: PropTypes.func,
  inputMergeName: PropTypes.string.isRequired,
  setInputMergeName: PropTypes.func,
  setOpenModalMerge: PropTypes.func,
  setTypeMerge: PropTypes.func,
  typeMerge: PropTypes.string,
  dataSelection: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.object),
    totalPages: PropTypes.number,
    currentPage: PropTypes.number.isRequired,
  }).isRequired,
  setExistingDataSelected: PropTypes.func,
  existingDataSelected: PropTypes.string,
  searchDataToMerge: PropTypes.func,
  setIsDialogAlertOpen: PropTypes.func,
  isDialogAlertOpen: PropTypes.bool,
  dialogAlertMessage: PropTypes.string,
  sortUserSubmissionData: PropTypes.func.isRequired,
  userSubmissionFilter: PropTypes.shape({}).isRequired,
  dataTypeActive: PropTypes.string.isRequired,
  dataLiveSelected: PropTypes.arrayOf(PropTypes.object),
}

export default TagUserSubmission
